const inputNumberFormatter = (value: any) => {
	if (!value) return value;
	const [integerPart, decimalPart] = `${value}`.split('.');
	const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	return decimalPart
		? `${formattedInteger},${decimalPart}`
		: formattedInteger;
};

const inputNumberParser = (value: any) => {
	if (!value) return value;
	let rawValue = value.replace(/\./g, '');
	rawValue = rawValue.replace(/,/, '.');
	return rawValue;
};

export { inputNumberFormatter, inputNumberParser };